import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export const seo = {
    title: "Sitemap | Aooz Status",
    description: "Explore all pages of Aooz Status. Easily navigate through categories, status collections, and important pages on status.aooz.in.",
    keywords: "aooz sitemap, status aooz sitemap, status website pages, aooz status navigation",
    url: "https://status.aooz.in/sitemap",
    image: "https://status.aooz.in/logo.png"
};

export default function Sitemap() {

    return (
        <div>

            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                <meta name="keywords" content={seo.keywords} />
                <meta property="og:title" content={seo.title} />
                <meta property="og:description" content={seo.description} />
                <meta property="og:image" content={seo.image} />
                <meta property="og:url" content={seo.url} />
            </Helmet>

            <div className="container_roots">
                <div className="container_size_info p-3">

                    <h2 className="text-xl font-bold mb-4">Sitemap</h2>

                    <div className="ui-grid text-pre-30">
                        <div className="ui-items">
                            <h4>Main Pages</h4>
                            <ul>
                                <li><Link to="/">Home</Link></li>
                                <li><Link to="/recommended">Recommended Status</Link></li>
                                <li><Link to="/punjabi-status">Punjabi Status</Link></li>
                                <li><Link to="/english-status">English Status</Link></li>
                            </ul>
                        </div>
                        <div className="ui-items">
                            <h4>Status Categories</h4>
                            <ul>
                                <li><Link to="/status/love">Love Status</Link></li>
                                <li><Link to="/status/sad">Sad Status</Link></li>
                                <li><Link to="/status/motivation">Motivational Status</Link></li>
                                <li><Link to="/status/loneliness">Loneliness Status</Link></li>
                                <li><Link to="/status/friendship">Friendship Status</Link></li>
                            </ul>
                        </div>
                        <div className="ui-items">
                            <h4>Legal Pages</h4>
                            <ul>
                                <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
                                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                                <li><Link to="/disclaimer">Disclaimer</Link></li>
                            </ul>
                        </div>
                        <div className="ui-items">
                            <h4>Other Pages</h4>
                            <ul>
                                <li><Link to="/support">Support</Link></li>
                                <li><Link to="/sitemap">Sitemap</Link></li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>

        </div>
    );
}